import React, { useContext, useEffect, useRef, useState } from 'react'
import { LookupAccountPageWrapper } from './LookupAccountPageStyled'
import { LoadingContext } from 'react-router-loading'
import { Typography } from 'antd'
import { Helmet } from 'react-helmet'
import Step1Search from '../../components/Step1Search'
import Step2RegisterInfo from '../../components/Step2RegisterInfo'
import { ConditionView } from '../../components/CommonStyled/CommonStyled'
import Step3AHold from '../../components/Step3AHold'
import Step3BNotHold from '../../components/Step3BNotHold'
import ConditionRender from '../../components/ConditionRender'
import { useResetRecoilState } from 'recoil'
import { accessTokenState } from '../../recoil/authenticationState'

const { Text } = Typography

const LookupAccountPage = props => {
  const [progressStep, setProgressStep] = useState('1')
  const [chosenAccount, setChosenAccount] = useState({})
  const [customerInfo, setCustomerInfo] = useState({})
  const step1Ref = useRef(null);
  const step2Ref = useRef(null);
  const step3BRef = useRef(null);

  const resetAccessToken = useResetRecoilState(accessTokenState)

  const handleNextToStep2 = (objAccount) => {
    setChosenAccount(objAccount)
    setProgressStep('2')
  }
  const handleBackToStep1 = () => {
    setChosenAccount({})
    setProgressStep('1')
  }
  const handleCancelToStep1 = () => {
    setChosenAccount({})
    setProgressStep('1')
    step1Ref.current.resetForm();
    step2Ref.current.resetForm();
    step3BRef.current.resetForm();
    resetAccessToken()
  }
  const handleNextToStep3 = (response) => {
    setCustomerInfo(response)
    if (response.hold) {
      setProgressStep('3A')
    } else {
      setProgressStep('3B')
    }
  }
  const handleBackToStep2 = () => {
    setCustomerInfo(null)
    setProgressStep('2')
  }

  useEffect(() => {
  }, [progressStep])

  // region loading
  const loadingContext = useContext(LoadingContext)
  const loading = async () => {
    loadingContext.done()
  }
  useEffect(() => {
    loading()
  }, [])
  // endregion
  return (
    <LookupAccountPageWrapper>
      <Helmet>
        <title>Chọn tài khoản số đẹp</title>
      </Helmet>
      <ConditionView visible={progressStep === '1'}>
        <Step1Search nextStep={handleNextToStep2} ref={step1Ref} />
      </ConditionView>
      <ConditionView visible={progressStep === '2'}>
        <Step2RegisterInfo accountInfo={chosenAccount} onClickBack={handleBackToStep1} onCancel={handleCancelToStep1} nextStep={handleNextToStep3} ref={step2Ref} />
      </ConditionView>
      <ConditionView visible={progressStep === '3A'}>
        <Step3AHold accountInfo={chosenAccount} customerInfo={customerInfo} onClickBack={handleBackToStep2} onCancel={handleCancelToStep1} />
      </ConditionView>
      <ConditionView visible={progressStep === '3B'}>
        <Step3BNotHold
          accountInfo={chosenAccount}
          customerInfo={customerInfo}
          onCancel={handleCancelToStep1}
          onClickBack={handleBackToStep2}
          ref={step3BRef}
        />
      </ConditionView>
    </LookupAccountPageWrapper>
  )
}

LookupAccountPage.propTypes = {}

export default LookupAccountPage
